<button
  type="button"
  nvButton="icon"
  size="sm"
  aria-label="Toggle navigation"
  (click)="toggleRail.emit()"
>
  <nv-icon>menu</nv-icon>
</button>

<div class="nv-header__title">
  <span class="nv-header__page-title">{{ pageTitle() }}</span>
  @if (subtitle(); as sub) {
    <span class="nv-header__crumb">{{ sub }}</span>
  }
</div>

<span class="nv-header__shift">
  <span class="nv-header__shift-dot" aria-hidden="true"></span>
  {{ shiftLabel() }}
</span>

<div class="nv-header__search" cdkOverlayOrigin #searchOrigin="cdkOverlayOrigin">
  <nv-icon [size]="18" class="nv-header__search-icon">search</nv-icon>
  <input
    class="nv-header__search-input"
    type="search"
    placeholder="Search tables, orders, items"
    aria-label="Search tables, orders, items"
    [value]="searchQuery()"
    (input)="searchQuery.set($any($event.target).value)"
    (focus)="openSearch()"
  />
  @if (searchQuery()) {
    <button type="button" class="nv-header__search-clear" aria-label="Clear search" (click)="clearSearch()">
      <nv-icon [size]="16">close</nv-icon>
    </button>
  }
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="searchOrigin"
  [cdkConnectedOverlayOpen]="searchOpen()"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="closeSearch()"
  (detach)="searchOpen.set(false)"
>
  <div class="nv-header__panel" tabindex="-1" (keydown.escape)="closeSearch()">
    <nv-header-search-results [query]="searchQuery()" (closed)="closeSearch()" />
  </div>
</ng-template>

@if (canUseAi()) {
  <a routerLink="/ai" nvButton="secondary" size="sm" class="nv-header__ask-ai" aria-label="Ask AI">
    <nv-icon [size]="16">auto_awesome</nv-icon>
    <span class="nv-header__ask-ai-label">Ask AI</span>
  </a>
}

@if (canStartOrder()) {
  <button type="button" nvButton="primary" class="nv-header__new-order" aria-label="New order" (click)="newOrder()">
    <nv-icon [size]="20">add</nv-icon>
    <span class="nv-header__new-order-label">New order</span>
  </button>
}

<div cdkOverlayOrigin #bellOrigin="cdkOverlayOrigin">
  <button
    type="button"
    nvButton="icon"
    size="sm"
    class="nv-header__bell"
    [attr.aria-label]="'Notifications' + (notificationCount() ? ', ' + notificationCount() + ' new' : '')"
    (click)="toggleNotifications()"
  >
    <nv-icon [size]="18">notifications</nv-icon>
    @if (notificationCount() > 0) {
      <span class="nv-header__bell-badge" aria-hidden="true">{{ notificationCount() }}</span>
    }
  </button>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="bellOrigin"
  [cdkConnectedOverlayOpen]="notifOpen()"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="closeNotifications()"
  (detach)="notifOpen.set(false)"
>
  <div class="nv-header__panel" tabindex="-1" (keydown.escape)="closeNotifications()">
    <nv-header-notifications-panel (closed)="closeNotifications()" />
  </div>
</ng-template>

<button type="button" class="nv-header__profile" [nvMenuTriggerFor]="accountMenu" [attr.aria-label]="'Account: ' + displayName()">
  <span class="nv-header__avatar">{{ initials() }}</span>
  <span class="nv-header__profile-text">
    <span class="nv-header__profile-name">{{ displayName() }}</span>
    <span class="nv-header__profile-role">{{ roleLabel() }}</span>
  </span>
</button>

<ng-template #accountMenu>
  <div nvMenu>
    @if (currentEmail(); as email) {
      <div class="nv-header__menu-email">{{ email }}</div>
    }
    @if (currentEmail()) {
      <button type="button" nvMenuItem [disabled]="sendingReset()" (click)="resetOwnPassword()">
        <nv-icon [size]="18">lock_reset</nv-icon>
        <span>Reset my password</span>
      </button>
    }
    <button type="button" nvMenuItem (click)="signOut()">
      <nv-icon [size]="18">logout</nv-icon>
      <span>Sign out</span>
    </button>
  </div>
</ng-template>
